import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { EditProvider } from './context/EditContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import NeuralNetworkBackground from './components/NeuralNetworkBackground';
import CookieConsent from './components/CookieConsent';
import SEO from './components/SEO';
import Home from './pages/Home';
import Services from './pages/Services';
import Infrastructure from './pages/Infrastructure';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import NotFound from './pages/NotFound';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <EditProvider>
        <Router>
          <ScrollToTop />
          <SEO />
          <div className="app">
            <NeuralNetworkBackground />
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/infrastructure" element={<Infrastructure />} />
                <Route path="/news" element={<News />} />
                <Route path="/news/:slug" element={<NewsDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <CookieConsent />
          </div>
        </Router>
      </EditProvider>
    </HelmetProvider>
  );
}

export default App;
